import EntityInfoLabel from '../EntityInfoLabel';
// Types
import type { UserInfo } from '@trii/types/dist/Users';

type Props = {
  title: string;
  value?: string | Date;
  isNotEditable?: boolean;
  inputType?: 'text' | 'select' | 'selectMembers';
  options?: UserInfo[];
  displayValue?: string;
  constructUpdateObject?: (value: string | Date) => object;
  baseUrl?: string;
  spaceId?: string;
  businessId?: string;
  onEntityUpdated?: (entity: unknown) => void;
};

const BusinessInfoLabel = ({
  title,
  value,
  isNotEditable,
  inputType = 'text',
  options = [],
  displayValue,
  constructUpdateObject,
  baseUrl,
  spaceId,
  businessId,
  onEntityUpdated,
}: Props) => {
  return (
    <EntityInfoLabel
      entityType="business"
      entityId={businessId}
      title={title}
      value={value}
      isNotEditable={isNotEditable}
      inputType={inputType}
      options={options}
      displayValue={displayValue}
      constructUpdateObject={constructUpdateObject}
      baseUrl={baseUrl}
      spaceId={spaceId}
      onEntityUpdated={onEntityUpdated}
    />
  );
};

export default BusinessInfoLabel;
